import { Injectable } from "@angular/core";
import { SegmentService } from "@main-services/segment.service";
import { LaunchpadAsset } from "@modules/launchpad/domain/entities/launchpad-asset";
import { RudderstackService } from "@main-services/rudderstack.service";

@Injectable({
	providedIn: "root"
})
export class LaunchpadTrackingFacade {
	constructor(
		private readonly segmentService: SegmentService,
		private readonly rudderstackService: RudderstackService
	) {}

	public trackNewsletterSubscribe(subscribed: boolean): void {
		this.segmentService.track({
			name: "Subscribe to Spotlight General",
			properties: {
				preference_spotlight_general: subscribed
			}
		});
		this.rudderstackService.track({
			name: "Subscribe to Spotlight General",
			properties: {
				preference_spotlight_general: subscribed
			}
		});
	}

	public trackAssetSubscribe(symbol: string, subscribed: boolean): void {
		this.segmentService.track({
			name: "Subscribe to Spotlight Individual asset",
			properties: {
				preference_spotlight_asset: symbol,
				preference_spotlight_asset_value: subscribed
			}
		});
		this.rudderstackService.track({
			name: "Subscribe to Spotlight Individual asset",
			properties: {
				preference_spotlight_asset: symbol,
				preference_spotlight_asset_value: subscribed
			}
		});
	}

	public trackBuyButtonClick(assetSymbol: string, location: string): void {
		this.segmentService.track({
			name: "Buy Button Clicked",
			properties: {
				screen_it_happened_on: location,
				asset_symbol: assetSymbol
			}
		});
		this.rudderstackService.track({
			name: "Buy Button Clicked",
			properties: {
				screen_it_happened_on: location,
				asset_symbol: assetSymbol
			}
		});
	}

	public trackBannerClick(location: string): void {
		this.segmentService.track({
			name: "Spotlight banner CTA Clicked",
			properties: {
				screen_it_happened_on: location
			}
		});
		this.rudderstackService.track({
			name: "Spotlight banner CTA Clicked",
			properties: {
				screen_it_happened_on: location
			}
		});
	}

	public trackSubscribeClick(asset: LaunchpadAsset, location: string): void {
		if (asset.is_subscribed) {
			this.segmentService.track({
				name: "Spotlight Coin Unsubscribe Button Clicked",
				properties: {
					screen_it_happened_on: location,
					asset_symbol: asset.symbol
				}
			});
			this.rudderstackService.track({
				name: "Spotlight Coin Unsubscribe Button Clicked",
				properties: {
					screen_it_happened_on: location,
					asset_symbol: asset.symbol
				}
			});
		} else {
			this.segmentService.track({
				name: "Spotlight Coin Subscribe Button Clicked",
				properties: {
					screen_it_happened_on: location,
					asset_symbol: asset.symbol
				}
			});
			this.rudderstackService.track({
				name: "Spotlight Coin Subscribe Button Clicked",
				properties: {
					screen_it_happened_on: location,
					asset_symbol: asset.symbol
				}
			});
		}
	}

	public trackLearnMoreClick(): void {
		this.segmentService.track({
			name: "Learn More Button Clicked",
			properties: {
				screen_it_happened_on: "spotlight page"
			}
		});
		this.rudderstackService.track({
			name: "Learn More Button Clicked",
			properties: {
				screen_it_happened_on: "spotlight page"
			}
		});
	}

	public trackBuyBestClick(): void {
		this.segmentService.track({
			name: "Buy BEST Button Clicked",
			properties: {
				screen_it_happened_on: "spotlight page"
			}
		});
		this.rudderstackService.track({
			name: "Buy BEST Button Clicked",
			properties: {
				screen_it_happened_on: "spotlight page"
			}
		});
	}

	public trackPageView(): void {
		this.segmentService.track({
			name: "Spotlight Page Viewed"
		});
		this.rudderstackService.track({
			name: "Spotlight Page Viewed"
		});
	}

	public trackFeaturedAssetClick(symbol: string): void {
		this.segmentService.track({
			name: "Featured Asset Card Clicked",
			properties: {
				screen_it_happened_on: "Spotlight pre-launch ADP",
				asset_symbol: symbol
			}
		});
		this.rudderstackService.track({
			name: "Featured Asset Card Clicked",
			properties: {
				screen_it_happened_on: "Spotlight pre-launch ADP",
				asset_symbol: symbol
			}
		});
	}

	public trackTimespanFilterClick(timespan: string): void {
		this.segmentService.track({
			name: "Time Filter Clicked",
			properties: {
				time: timespan,
				screen_it_happened_on: "spotlight page live projects list"
			}
		});
		this.rudderstackService.track({
			name: "Time Filter Clicked",
			properties: {
				time: timespan,
				screen_it_happened_on: "spotlight page live projects list"
			}
		});
	}

	public trackVisionBannerSeen(vision_banner_type: string): void {
		this.segmentService.track({
			name: "Vision Banner Seen",
			properties: {
				screen_it_happened_on: "spotlight screen",
				vision_banner_type
			}
		});
		this.rudderstackService.track({
			name: "Vision Banner Seen",
			properties: {
				screen_it_happened_on: "spotlight screen",
				vision_banner_type
			}
		});
	}

	public trackVisionBannerLearnMoreClicked(vision_banner_type: string): void {
		this.segmentService.track({
			name: "Vision Banner Learn More Button Clicked",
			properties: {
				screen_it_happened_on: "spotlight screen",
				vision_banner_type
			}
		});
		this.rudderstackService.track({
			name: "Vision Banner Learn More Button Clicked",
			properties: {
				screen_it_happened_on: "spotlight screen",
				vision_banner_type
			}
		});
	}

	public trackVisionBannerCTAClicked(vision_banner_type: string): void {
		this.segmentService.track({
			name: "Vision Banner CTA Clicked",
			properties: {
				screen_it_happened_on: "spotlight screen",
				vision_banner_type
			}
		});
		this.rudderstackService.track({
			name: "Vision Banner CTA Clicked",
			properties: {
				screen_it_happened_on: "spotlight screen",
				vision_banner_type
			}
		});
	}
}
